import React, { useMemo } from 'react';
import "@/pages/intelligence/assets/scss/MarketProfile/AnnualReport/index.scss";
import { useIntl } from 'umi';
import { Row, Col, Card, Select } from 'tea-component';
import * as echarts from 'echarts';
import Loading from '@/pages/intelligence/components/Loading';
import MarketCardContext from "@/pages/intelligence/pages/MarketProfile/components/MarketCardContext";
import MarketTableCard from "@/pages/intelligence/pages/MarketProfile/components/MarketTableCard";
import useMobileGameModel from '@/pages/intelligence/pages/MarketProfile/hooks/useMobileGamesModel'
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import './index.scss';

// 报告有数据的第一年
const FIRST_YEAR_WITH_DATA_OF_REPORT = 2019;

export default function AnnualReport(props: any) {
  const { regionsCountries } = props || {};
  // 获取当前年往前推一年
  const lastYear = useMemo(() => {
    return new Date().getFullYear() - 1;
  }, []);
  // 从2019年开始，到lastYear，自动生成下拉列表
  const annualOptions = useMemo(() => {
    const tmpArr = [];
    let firstYear = FIRST_YEAR_WITH_DATA_OF_REPORT;
    let dValue = lastYear - firstYear + 1;
    while(dValue) {
      tmpArr.unshift({
        text: firstYear.toString(),
        value: firstYear,
      });
      firstYear++;
      dValue--;
    };
    return tmpArr;
  }, [lastYear]);
  const { formatMessage } = useIntl()
  const {
    showTableData,
    time,
    changeChartType,
    changeMarketProfileAll,
    selectedKeys,
    selectAllKeys,
    setSelectedKeys,
    chartType,
    setChartType,
    tableLoading,
    ieggGenre,
    countrySet,
    selectedMarket,
    onMarketSelectorChange,
    onConfirmMarketSelector,
    selectSearchMarketList,
    allSearchMarketsList,
    setSearchKeyWord,
    searchKeyWord,
    filterData,
    sortColunms,
    changeMpTableSort,
    yearData,
    annualOptionsValue,
    annualYearSummary,
    dataSearch,
    setAnnualOptionsValue,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    lineTrendData
  } = useMobileGameModel({ pageId: 'MarketProfilAnnualReport', defaultYear: lastYear });

  const summaryData = {
    title: `${annualOptionsValue} ${formatMessage({ id: 'dbi_revenue_$' })}`,
    num: annualYearSummary['yearTotal'] == 0 ? '-' : formatNum(annualYearSummary['yearTotal'], true),
    text: `YoY`,
    trend: annualYearSummary['yearTotalPrecent'] == 0 ? '-' : `${formatPercentNum(annualYearSummary['yearTotalPrecent'])}`,
    isUp: annualYearSummary['yearTotalPrecent'] >= 0,
    content: `对比(${annualOptionsValue - 1})${annualYearSummary['yearTotalPrecent'] > 0 ? '增长了' : '降低了'}
    ${formatPercentNum(
      annualYearSummary['yearTotalPrecent'],
    )}`
  }

  const changeSearchKeyWord = (keywords: any) => {
    setSearchKeyWord(keywords)
  }

  return (
    <div className='dbi-marketprofile--annualreport'>
      <div className='dbi-marketprofile-filter'>
        <Select
          className="dbi-marketprofile-select"
          appearance="button"
          matchButtonWidth
          options={annualOptions}
          value={annualOptionsValue}
          onChange={(value: any) => {
            let _params = { year: value + '' };
            dataSearch(_params, false);
            let mapChartDom = document.getElementById(
              'mpAnnualSummaryCharts',
            );
            if (mapChartDom) {
              let myMapChart = echarts.init(mapChartDom);
              if (myMapChart) {
                myMapChart.dispose();
              }
            }
            setAnnualOptionsValue(value);
          }}
          placeholder="请选择年份"
          button={(option) => (
            <div className="select-button">
              <div className="select-button-text">{formatMessage({ id: 'dbi_date' })}</div>
              {
                annualOptions?.filter((e) => {
                  return e.value == annualOptionsValue;
                })[0]?.text
              }
            </div>
          )}
        />
      </div>


      <Card className='annualreport-summary'>
        <Card.Body title={formatMessage({ id: 'dbi_market_global_sum' })}>
          <Row className='annualreport-summary-cont'>
            <Col span={6} className='annualreport-summary-width'>
              {tableLoading ? <div style={{ height: 174 }}><Loading content={formatMessage({ id: 'common_loading' })} /></div> : <MarketCardContext data={summaryData} />}
            </Col>

            <Col className='annualreport-summary-chart'>
              <Loading content={formatMessage({ id: 'common_loading' })} style={{ display: tableLoading ? 'flex' : 'none'}} classNameValue="annualreport-summary-chart-loading"/>
              <div className='annualreport-echarts' id="mpAnnualSummaryCharts"></div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <MarketTableCard
        pageId='MarketProfilAnnualReport'
        isNoselect={tableLoading}
        title={formatMessage({ id: 'dbi_market_distribution' })}
        loading={tableLoading}
        activeTab={chartType}
        iconList={[]}
        tableData={showTableData}
        ieggGenre={ieggGenre}
        time={time}
        countrySet={countrySet}
        selectedMarket={selectedMarket}
        onMarketSelectorChange={onMarketSelectorChange}
        onConfirmMarketSelector={onConfirmMarketSelector}
        selectSearchMarketList={selectSearchMarketList}
        allSearchMarketsList={allSearchMarketsList}
        setSearchKeyWord={setSearchKeyWord}
        changeSearchKeyWord={changeSearchKeyWord}
        changeChartType={changeChartType}
        changeMpTableSort={changeMpTableSort}
        sortColunms={sortColunms}
        yearData={yearData}
        filterData={filterData}
        searchKeyWord={searchKeyWord}
        mapData1={mapData1}
        mapData2={mapData2}
        mapData3={mapData3}
        mapData4={mapData4}
        chartType={chartType}
        lineTrendData={lineTrendData}
        regionsCountries={regionsCountries}
      />
    </div>
  )
}
